/* @flow */

import * as React from 'react';

import './Item.css';
import './PlaceholderItem.css';

const PlaceholderItem = (): React.Node => (
  <div className='sectionItem placeholder'>
    <div className='tileContainer' />
    <div className='textContainer'>
      <div className='text' />
      <div className='text secondLineInfo' />
    </div>
  </div>
);

export default PlaceholderItem;
